export default __webpack_public_path__ + "static/media/introBackground.915696c5.png";